import { BreadcrumbsContainer, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, Separator, IconWrapper } from './breadcrumbs.style';
import { BreadcrumbsComponentTypes } from './breadcrumbs.types';

const Breadcrumbs = ({
  items,
  separator = '/',
  maxItems,
  activeLastBreadcrumb = false,
  showIcons = false,
  style,
  color,
  separatorColor,
  icon,
  size = 'medium',
  ...props
}) => {
  const displayedItems = maxItems ? items.slice(-maxItems) : items;

  const handleClick = (e, item, isLast) => {
    e.preventDefault();
    if (isLast && !activeLastBreadcrumb) {
      return;
    }
    if (item.onClick) {
      item.onClick(e);
    } else if (item.to) {
      window.location.href = item.to;
    }
  };

  return (
    <BreadcrumbsContainer style={style} aria-label="breadcrumb" $size={size} {...props} >
      <BreadcrumbList>
        {/* Add vertical line at the start */}
        <span style={{ color: '#bbb', marginRight: 8, fontWeight: 400, fontSize: size === 'small' ? 18 : 22, verticalAlign: 'middle' }}>|</span>
        {
          displayedItems.map((item, index) => {
            const isLast = index === displayedItems.length - 1;

            return (
              <BreadcrumbItem
                key={item.label}
                $isLast={isLast}
                $activeLastBreadcrumb={activeLastBreadcrumb}
                $size={size}
                $color={color}
              >
                <BreadcrumbLink
                  href={item.to}
                  onClick={(e) => handleClick(e, item, isLast)}
                  $color={color}
                >
                  {
                    showIcons && item.icon && (
                      <IconWrapper $size={size} >
                        <item.icon />
                      </IconWrapper>
                    )
                  }
                  {item.label}
                </BreadcrumbLink>
                {!isLast && <Separator $separatorColor={separatorColor} $size={size}>{separator}</Separator>}
              </BreadcrumbItem>
            );
          })
        }
      </BreadcrumbList>
    </BreadcrumbsContainer>
  );
};

Breadcrumbs.propTypes = BreadcrumbsComponentTypes;

export default Breadcrumbs;